import { useQuery } from '@tanstack/react-query'
import { getAllRoles } from '../../../api/users/getAllRoles'

export const useGetAllRoles = () => {
  return useQuery({
    queryKey: ['allRoles'],
    queryFn: getAllRoles,
    staleTime: 1000 * 60 * 60,
    retry: 1
  })
}